import * as React from 'react'
import { TerminalNodeInterpreter } from '../model/TerminalNodeInterpreter';
import { IStableTerminalNode } from '../model/TerminalScore';
import { TerminalScoreContext } from '../TerminalScoreProvider';
import humanizeDuration from "humanize-duration";
import { BtcInfoContext } from '../../general/SatoshiPriceProvider';
import NumberFormat from 'react-number-format';
import { GraphEdge } from '../../graph/models/GraphEdge.interface';
import { Tooltip } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import AmbossNodeLink from '../../general/AmbossNodeLink';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckIcon from '@mui/icons-material/Check';
import GradeIcon from '@mui/icons-material/Grade';
import Link from 'next/link';
import TerminalPeerChannelRow from './TerminalPeerChannelRow';

type Props = {
  edges: GraphEdge[],
  className?: string
}

const TerminalStablePeersRow: React.FC<Props> = ({ edges, className = '' }) => {
  const [displayHiddenEdges, setDisplayHiddenEdges] = React.useState<boolean>(false);
  const { graph, terminalScore } = React.useContext(TerminalScoreContext);
  const { currentBlockHeight } = React.useContext(BtcInfoContext);

  const node = graph.getNode(edges[0].target);
  const peer = graph.getNode(edges[0].source);

  const terminalNode = terminalScore.getNode(node.id);
  const myStatus = terminalScore.getNodeStatus(node.id);

  const isScoreInboundPeer = myStatus === 'unstable' ? false : (terminalNode as IStableTerminalNode).stable_inbound_peers.includes(peer.id);
  const isScoreOutboundPeer = myStatus === 'unstable' ? false : (terminalNode as IStableTerminalNode).stable_outbound_peers.includes(peer.id);

  const displayedEdges = displayHiddenEdges ? edges : edges.slice(0, 1);

  const cellClasses = 'pr-4 py-2 pl-2'
  return (
    <tr className="hover:bg-gray-100 border-t">
      <td className={cellClasses + ''} >
        <div>

          <div className="flex items-center my-2">
            <div className="text-lg overflow-ellipsis overflow-hidden inline-block hover:text-viking-800 md:max-w-[250px] lg:max-w-[300px] max-w-[180px]">
              <Link href={'/scores/terminal?id=' + peer.id}><a>{peer.label}</a></Link>
            </div>
            <AmbossNodeLink className="text-gray-300 text-sm pl-1 hover:text-gray-700" nodeId={peer.id} >
              <OpenInNewIcon fontSize="inherit" />
            </AmbossNodeLink>
          </div>

          <table className="w-full ml-12 mt-4 mb-2">
            <tbody>
              {displayedEdges.map(edge =>
                <TerminalPeerChannelRow edge={edge} />
              )}
            </tbody>
          </table>
          {edges.length > 1 && !displayHiddenEdges &&
            <div>
              <p className="ml-14 text-xs cursor-pointer hover:text-opacity-100 text-gray-700 text-opacity-60" 
              onClick={() => setDisplayHiddenEdges(true)}>
                Show {edges.length - 1} more channels with this peers.
                </p>
            </div>
          }
        </div>
      </td>
      <td className={cellClasses + ' align-top w-12'}>
        <div className="pt-3">
          {isScoreInboundPeer &&
            <Tooltip title="Acknowledge by Terminal as a stable inbound peer." arrow leaveTouchDelay={5000} enterTouchDelay={1}>
              <div className="text-xs text-gray-700 flex items-center">
                <CheckCircleIcon className="text-viking-800 mr-1" fontSize="inherit" /> Inbound
              </div>
            </Tooltip>
          }
          {isScoreOutboundPeer &&
            <Tooltip title="Acknowledge by Terminal as a stable outbound peer." arrow leaveTouchDelay={5000} enterTouchDelay={1}>
              <div className="text-xs text-gray-700 flex items-center">
                <CheckCircleIcon className="text-viking-800 mr-1" fontSize="inherit" /> Outbound
              </div>
            </Tooltip>
          }

        </div>

      </td>
    </tr>
  );
}

export default TerminalStablePeersRow;

